import { render } from "./SeriesSelectorText.vue?vue&type=template&id=67ce5b80"
import script from "./SeriesSelectorText.vue?vue&type=script&lang=js"
export * from "./SeriesSelectorText.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__